module.exports = __webpack_public_path__ + "static/media/retarded.f0a825d3.wav";